import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { K_CARE_SECTION } from '../../Constants/KCare';
import FAQTabs from '../../components/Accordion';

// CSS
import './k_care.css';
import BottomSignupGradient from '../../components/bottom_signup_gradient';
import AppNavBar from '../../helper/appbar';

const KCare = () => {
    const freeSignUp = () => window.open("http://app.gokardinal.com/onboarding", "_blank");
    return (
        <main className='kcare_section_main'>
            <AppNavBar navType={'dark'} />
            <section className='kcare_section_1'>
                <Container fluid>
                    <Row>
                        <Col sm={12} lg={6}>
                            <h1>The responsible way to travel</h1>
                            <p>Comprehensive security, regulatory and safety support at every stage of journey.</p>
                            <button onClick={freeSignUp}>Sign up for free <ArrowForwardIcon /></button>
                        </Col>
                        <Col sm={12} lg={6}>
                            <img
                                src={require('../../assets/kcare/sec1_kcare.png')}
                                alt={"k-care"}
                                loading={"lazy"}
                            />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='kcare_section_2'>
                <aside>
                    <div className='kcare_section_container_main'>
                        {K_CARE_SECTION.map((item, index) => {
                            return (
                                <div key={index} className='kcare_section_container'>
                                    <div>
                                        <h1>{item.title}</h1>
                                        <p>{item.description}</p>
                                    </div>
                                    <img src={item.svg_desktop} alt="kcare_section_2_desktop" loading='lazy' />
                                    <img src={item.svg_mobile} alt="kcare_section_2_desktop" loading='lazy' />
                                </div>
                            );
                        })}
                    </div>
                </aside>
                <ChevronRightIcon />
            </section>

            <section className='kcare_section_3'>
                <h1>Start piortizing your employees welfare</h1>
                <button onClick={freeSignUp}>Sign up now</button>
            </section>

            <section className='kcare_section_4'>
                <h1>Frequently asked questions</h1>
                <FAQTabs activeKey={3} />
            </section>

            <section className='kcare_section_5'>
                <BottomSignupGradient
                    type={`Save cost on travel & expense`}
                />
            </section>
        </main>
    );
};

export default KCare;